import { CoralException } from '@ch-types/CoralException';

export default class InternalFailure extends CoralException {}
